import { useState } from 'react'
import { PAGE_SIZE } from 'utils/constants'

export const usePagination = ({ canPaginate, sortFields, useGetQuery }) => {
  const [queryOptions, setQueryOptions] = useState({
    filter: {
      sort: {
        field: sortFields,
        ascending: true,
      },
      search: '',
    },
    page: 1,
    pageSize: PAGE_SIZE,
  })

  const { data: listData, isLoading } = useGetQuery(
    {
      ...(canPaginate && queryOptions),
      filter: JSON.stringify(queryOptions.filter),
    },
    { skip: !queryOptions.filter?.sort?.field },
  )

  const paginationProps = {
    filter: queryOptions?.filter,
    setFilter: newFilter => setQueryOptions(prevState => ({ ...prevState, filter: newFilter })),
    ...(canPaginate && {
      rowCount: listData?.totalResultsCount || 0,
      paginationMode: 'server',
      useBackendSortAndFilter: true,
      onPageChange: newPageNumber => setQueryOptions(prevState => ({ ...prevState, page: newPageNumber + 1 })),
      onPageSizeChange: newPageSize => setQueryOptions(prevState => ({ ...prevState, pageSize: newPageSize })),
      setQueryOptions,
      autoPageSize: false,
      pageSize: queryOptions.pageSize,
    }),
  }

  return {
    paginationProps,
    listData,
    isLoading,
  }
}
